module.exports = __webpack_public_path__ + "img/proage-logo.33e8da06.png";